import { Link } from "react-router-dom";

export default function DashboardFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="dashboard-footer" role="contentinfo">
      <div className="dashboard-footer-content">
        <div className="dashboard-footer-links" aria-label="Footer links">
          <Link to="/docs" className="dashboard-footer-link">
            Docs
          </Link>
          <span className="dashboard-footer-sep" aria-hidden="true">
            •
          </span>
          <Link to="/support" className="dashboard-footer-link">
            Support
          </Link>
          <span className="dashboard-footer-sep" aria-hidden="true">
            •
          </span>
          <Link to="/privacy" className="dashboard-footer-link">
            Privacy
          </Link>
          <span className="dashboard-footer-sep" aria-hidden="true">
            •
          </span>
          <Link to="/terms" className="dashboard-footer-link">
            Terms
          </Link>
          <span className="dashboard-footer-sep" aria-hidden="true">
            •
          </span>
          <a
            href="/third-party-licenses.txt"
            className="dashboard-footer-link"
          >
            Licenses
          </a>
        </div>

        <div className="dashboard-footer-meta">
          © {year} okeybot
        </div>
      </div>
    </footer>
  );
}
